import { IAnalyticsParams } from "@framework/provider-asu";

import { ANALYTICS_OBJECT, IObjectOption } from "../../interfaces";

export const findPendingPointOption = (
  options: IObjectOption[],
  pendingParams: IAnalyticsParams,
): IObjectOption | undefined => {
  if (pendingParams.objectId !== undefined) {
    return options.find(({ id }) => String(id) === String(pendingParams.objectId));
  }

  return options.find(({ title }) => title === pendingParams.objectTitle);
};

export const isPendingPointRequest = (
  pendingParams: IAnalyticsParams | null,
  idPoint: number,
): pendingParams is IAnalyticsParams =>
  pendingParams?.object === ANALYTICS_OBJECT.POINT &&
  (pendingParams.objectId === undefined || String(pendingParams.objectId) === String(idPoint));

export const shouldLoadPointParametersImmediately = (
  currentIdObject: string | number | null,
  resolvedIdObject: string | number | null | undefined,
): resolvedIdObject is string | number => resolvedIdObject != null && resolvedIdObject === currentIdObject;
